/**
 * Configure your Gatsby site with this file.
 *
 * See: https://www.gatsbyjs.org/docs/gatsby-config/
 */

module.exports = {
  proxy: {
    prefix: "/api",
    url: "https://signup-app.zervicepoint.com/api/",
  },
  siteMetadata: {
    title: "Sign up to Zervicepoint",
    siteUrl: "https://signup.zervicepoint.com/",
    description: "Build you own company portal including business automation and self-service",
  },
  plugins: [
    `gatsby-plugin-styled-components`,
    'gatsby-plugin-remove-serviceworker'
  ],
}
